import { Icon } from "./Icon.tsx";

/** "Map legend" icon — three swatches with their label, like the legend itself. Replaces the 🎨 emoji on the button that reopens it, which didn't fit the rest of the app's icons (all simple strokes, no emoji). */
export function LegendIcon() {
  return (
    <Icon>
      <rect x="3" y="4" width="4" height="4" rx="1" />
      <line x1="11" y1="6" x2="21" y2="6" />
      <rect x="3" y="10" width="4" height="4" rx="1" />
      <line x1="11" y1="12" x2="21" y2="12" />
      <rect x="3" y="16" width="4" height="4" rx="1" />
      <line x1="11" y1="18" x2="21" y2="18" />
    </Icon>
  );
}
